module.exports = __webpack_public_path__ + "img/43_BF21_extreme_weather.3a7b4bdc.jpg";